import React from "react";
import Loader from 'react-loader-spinner';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import Captcha from '../Custom Modules/Captcha.js';
import TextInput from './TextInput.js';
import MultilineTextFields from '../Material-UI-Components/MultilineTextFields.js';
import AlertDialog from '../Material-UI-Components/Dialog.js';

/* importing json modules */
import ContactFormField from '../Page-Data/Contact-Form.json';
 
export default class ContactForm extends React.Component {

    constructor(props){
        super(props);
        this.state={
          modalTitle:'',
          modalBody:'',
          loader: false,
          open: false
        };
        this.sendMail = this.sendMail.bind(this);
      }

    componentWillMount()
    {
      ContactFormField.map((index)=>{
        this.setState({[index.fieldName]:index.default ? index.default :''});
      });
    }

    setStateValueOnClick = (key, value) => {
      if(key === "query"){
        if(value.charAt(value.length-1) === "'"){
          
        }else{
          this.setState({[key]:value});
        }
      }else{
        this.setState({[key]:value});
      }
    };
      
    changePage = (history, pageURL) =>{
        history.push(pageURL);
      };

    setButtonVisible = (flag) => {
        this.setState({isButtonVisible: flag});
    };

      sendMail(){
        this.setState({loader:true});
        if(this.state["firstName"] !== null 
            && this.state["emailAddress"] !== null
            && this.state["query"] !== null
            && this.state["phoneNumber"] !== null
            && this.state["firstName"].trim().length>0
            && this.state["emailAddress"].trim().length>0
            && this.state["query"].trim().length>0
            && this.state["phoneNumber"].trim().length>0){
                fetch("https://www.api.pratiiti.in/public/sendMail",{
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify({"firstName":this.state["firstName"],"lastName":this.state["lastName"],
                    "emailAddress":this.state["emailAddress"],"query":this.state["query"],"phoneNumber":this.state["phoneNumber"]})
                  })
                    .then(res => res.json())
                    .then(
                      (result) => {
                        if(result.status === "Success"){
                            this.setState({open:true, loader:false, captcha:false, modalTitle:'Success', modalBody:'Thank you for contacting us. We will reach you shortly.'});
                        }
                        else if(result.status === "Fail"){
                            this.setState({open:true, loader:false, captcha:false, modalTitle:'Failure', modalBody:'Something went wrong.'});
                        }
                      }
                    )
                    .catch(
                      error =>  {
                          try {
                              error.json().then(body => {
                                  console.log(body);
                                  console.log("message = "+body.message);
                              });
                          } catch (e) {
                          } 
                          finally{
                            this.setState({open:true, loader:false, captcha:false, modalTitle:'Failure', modalBody:'Something went wrong.'});
                          }
                      }
                  );
        }else{
            this.setState({open:true, loader:false, captcha:false, modalTitle:'Failure', modalBody:'First Name, Email ID, Phone Number or Query cannot be empty.'});
        }
    }
  
  getTableContent = () => {
  
      const getFieldType = (nextItem) => {
        switch (nextItem.fieldType) {
          case "text":
            return (<TextInput value={this.state[nextItem.fieldName]} fieldConfiguration={nextItem} disableReadonly = {this.props.disableReadonly} onClickFunction = {this.setStateValueOnClick}/>);
          case "multiline":
            return (<MultilineTextFields value={this.state[nextItem.fieldName]} fieldConfiguration={nextItem} onClickFunction = {this.setStateValueOnClick}/>)
          case "captcha":
            return(<div style={{marginLeft: 10}}><Captcha onClickFunction = {this.setStateValueOnClick}/></div>)
          default:
            return null;
        }
      };
    
      const iterateItem = (item) => {
         return item.map(function (nextItem, j) {
           return (
              <Grid xs={11} sm={11} md={11}>{getFieldType(nextItem)}</Grid>
           );
         })
      }
          return (
                <Grid xs={12} sm={12} md={12}>
                {iterateItem(ContactFormField)}
                </Grid>
          );
    };
    

  render(){
    const elements = this.getTableContent(ContactFormField);
    return (
      <div>
        <div className="mainContainerContact">
            <div className="header">
            </div>
            <div className="contactFormBody">
                {elements}
                <div style={{marginLeft: 10}}>
                  {this.state.loader ? <Loader type="Circles" color="#f7941e" height={30} width={30}/> 
                  : <Button onClick={() => this.sendMail()} disabled={this.state.captcha} className={this.state.captcha ? "buttonDisabled" : ""} style={{marginTop:20, color: '#ffffff', backgroundColor: '#f7941e', fontSize: 16}}>{"Submit"}</Button>
                  }
                </div>
            </div>
        </div>
        <AlertDialog
          modalTitle={this.state.modalTitle}
          modalBody={this.state.modalBody}
          open={this.state.open}
          onClickFunction = {this.setStateValueOnClick}
        />
      </div>
    );
  }
}
